import { useState } from "react";
import TiltArrow from "../../../icons/TiltArrow";
import { LoadingSpinner } from "../../../icons/LoadingSpinner";
import { useRouter } from "next/router";
interface BlogsMenuCardProps {
  className?: string;
  tag?: string;
  textContent?: string;
  blogDate?: string;
  imageLink?: string;
  blogLink?: string;
}

import { Button } from "../ui/button";

export const BlogsHeroCard = ({
  className,
  tag,
  textContent,
  blogDate,
  imageLink,
  blogLink,
}: BlogsMenuCardProps) => {
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const handleClick = () => {
    try {
      setLoading(true);

      if (blogLink) router.push(blogLink);
      else setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error occured in redirection", error);
    }
  };
  return (
    <div
      className="space-y-4 lg:pb-2"
      // className={`bg-white w-full min-w-[320px] lg:min-w-0 hover:shadow-lg hover:scale-[1.01] hover:shadow-300 hover:duration-300 hover:ease-out`}
    >
      {/* IMAGE part */}
      <div className="flex w-full lg:max-w-[700px] h-[202px] lg:h-[265px] clip-path-bottomRightTool">
        <img className="w-full h-full object-cover" src={imageLink} alt="" />
      </div>

      {/* Blogs Data */}
      <div className="items-center flex  w-full   rounded-tr-lg rounded-br-lg">
        <p className="text-brand-bgBlack capitalize pl-2 pr-6 py-[6px] leading-4 lg:leading-5 text-mobile-body-sm lg:text-web-body-md font-semibold font-openSans bg-brand-lightBlue clip-path-topRightFourSidedBlogs">
          {tag}
        </p>

        <Button
          size={"custom"}
          variant={"custom"}
          onClick={handleClick}
          className="lg:hidden hover:cursor-pointer ml-auto mr-3"
        >
          {loading ? (
            <LoadingSpinner />
          ) : (
            <TiltArrow
              className="stroke-brand-bgBlack"
              height="37px"
              width="37px"
            />
          )}
        </Button>
      </div>
      {/* Text */}
      <div className="items-center flex  w-full ">
        <p className="font-openSans capitalize font-semibold text-mobile-body-lg lg:text-[22px] leading-[22px] text-brand-textBlack lg:max-w-[575px]">
          {textContent}
        </p>

        <Button
          size={"custom"}
          variant={"custom"}
          onClick={handleClick}
          className="hidden lg:flex hover:cursor-pointer ml-auto mr-3"
        >
          {loading ? (
            <LoadingSpinner />
          ) : (
            <TiltArrow
              className="stroke-brand-bgBlack"
              height="42px"
              width="42px"
            />
          )}
        </Button>
      </div>
    </div>
  );
};
